import React from "react";
import { useSelector } from "react-redux";
import { styled } from "@mui/material";
import { useHistory } from "react-router-dom";

import { PAYMENTS_STATUSES, STATUSES_COLOR } from "../../../../constants";
import { StyledTrWithHover } from "../../../../useGeneralStyles";

import { IStripeChargeInfo } from "../../../../api/stripe/index.types";
import { IntlFormatUSD } from "../../../../utils";
import { getTimeByAmericaChicagoTz } from "../../../../utils/moment";

interface IPros {
  groupBy: string;
}

const WithStatus = styled("span")((props: { status: string }) => {
  const styles = { padding: 5, backgroundColor: "transparent" };

  if (props.status === PAYMENTS_STATUSES.fraud.status) {
    styles.backgroundColor = STATUSES_COLOR.fraud;
  }
  if (props.status === PAYMENTS_STATUSES.chargeback.status) {
    styles.backgroundColor = STATUSES_COLOR.chargeback;
  }
  if (props.status === PAYMENTS_STATUSES.failed.status) {
    styles.backgroundColor = STATUSES_COLOR.failed;
  }
  return styles;
});

const TableBody = ({ groupBy }: IPros): React.ReactElement => {
  const history = useHistory();
  const { payments, retrievedCharges } = useSelector((state) => state.feed.data.failedPayments);

  const handleClick = (accounts_id: number) => history.push(`/customer/${accounts_id}`);
  return (
    <tbody>
      {payments.map((payment, index) => {
        const retrievedData = retrievedCharges[index];
        const { status, stripe_ch } = payment;
        const { all } = PAYMENTS_STATUSES;
        const stripeData: IStripeChargeInfo | undefined = retrievedCharges.find(
          ({ id }) => id === stripe_ch
        );

        return (
          <StyledTrWithHover
            key={`${payment.id}_${stripe_ch}`}
            onClick={() => handleClick(payment.accounts_id)}
            data-test="payment-status-row"
          >
            <td>
              {getTimeByAmericaChicagoTz(payment.purchase_date, true)}
              CT
            </td>
            <td>{payment.price_usd ? IntlFormatUSD(payment.price_usd / 100) : "n/a"}</td>
            <td>{payment.accounts_id}</td>
            <td>{payment.account.name}</td>
            <td>{payment.account.email}</td>
            <td>{retrievedData ? retrievedData.object : "n/a"}</td>
            <td>{payment.plan.name || "n/a"}</td>
            <td>{stripeData ? stripeData.failure_code : "n/a"}</td>
            <td>{stripeData ? stripeData.failure_message : "n/a"}</td>
            <td>{stripeData ? stripeData.outcome.seller_message : "n/a"}</td>

            {groupBy === all.status && (
              <td>
                <WithStatus status={status}>{status}</WithStatus>
              </td>
            )}
          </StyledTrWithHover>
        );
      })}
    </tbody>
  );
};

export default TableBody;
